import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-LeftArrowShape",
  "use": "svg-icon-LeftArrowShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg-icon-LeftArrowShape\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M3.814 7.15l10.34.004a.846.846 0 0 1 0 1.693l-10.34.003 4.657 4.656a.875.875 0 1 1-1.238 1.238L1.508 9.018C1.168 8.678 1 8.412 1 8c0-.412.155-.665.487-.998l5.746-5.746a.875.875 0 1 1 1.238 1.238L3.814 7.15z\" fill=\"#000\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol